import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Situation from "./pages/Situation";
import Resources from "./pages/Resources";
import { Toaster } from "./components/ui/sonner";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ color: "var(--ink-soft)" }}>
        …
      </div>
    );
  if (!user) return <Navigate to="/auth?mode=login" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route
              path="/"
              element={
                <PublicOnly>
                  <Landing />
                </PublicOnly>
              }
            />
            <Route
              path="/auth"
              element={
                <PublicOnly>
                  <Auth />
                </PublicOnly>
              }
            />
            <Route
              path="/dashboard"
              element={
                <Protected>
                  <Dashboard />
                </Protected>
              }
            />
            <Route
              path="/situation/:key"
              element={
                <Protected>
                  <Situation />
                </Protected>
              }
            />
            <Route
              path="/resources"
              element={
                <Protected>
                  <Resources />
                </Protected>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
